module.exports = __webpack_public_path__ + "src/img/start_pic2.jpg?cc635ff95f3a288fe831094043258c9d";


//////////////////
// WEBPACK FOOTER
// ./src/img/start_pic2.jpg
// module id = 200
// module chunks = 0